


































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required } from "vuelidate/lib/validators";
import CustomerService from "@/services/customer_service";
import { Validation } from "vuelidate";
import { CustomerSchema } from "@/models/customer_schema";
import { StoreModule } from "@/store/types";
import { CustomerActions } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { EventBus } from "@/events";
import { VMoney } from "v-money";
import Customer from "./Customer.vue";
import { discountAmt, discountHandle } from "@/validators/custom";
import { CustomerDiscounts } from "@/models/customer";
@Component({
  directives: { money: VMoney },
})
export default class Discounts extends Vue {
  protected $v: Validation;
  protected customerService = new CustomerService();
  protected forDeletion: number[] = [];
  protected validated = false;
  protected discounts: {
    display_name?: string;
    handle: string;
    amt: number | string;
  }[] = [];
  protected money = {
    decimal: ".",
    thousands: ",",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: true,
  };
  @Prop() data!: CustomerSchema;
  @(namespace(StoreModule.Customer).Action(CustomerActions.EditCustomer))
  editCustomer;
  @Validations()
  validations() {
    return {
      discounts: {
        $each: {
          handle: {
            discountHandle,
          },
          amt: {
            discountAmt,
          },
        },
      },
    };
  }

  created() {
    if (this.data.business_info) {
      if (this.data.business_info.discounts) {
        const data = JSON.parse(
          JSON.stringify(this.data.business_info.discounts)
        );
        this.discounts = data.map((d) => {
          d.amt = this.decimal.format(d.amt) as any;
          return d;
        });
      }
    }
  }

  beforeDestroy() {
    this.discounts = [];
  }

  public async handleSubmit(): Promise<void> {
    this.validated = false;
    if (this.discounts.length < 1) {
      this.$emit("close");
    } else if (this.forDeletion.length < 1) {
      this.validateNoDelete();
    } else {
      await this.validateDelete();
    }
  }

  private decimal = new Intl.NumberFormat("en-US", {
    minimumIntegerDigits: 1,
    minimumFractionDigits: 2,
  });

  /**
   * If there is atleast one item up for deletion, special validation is neccessary for every individual year object.
   * Need to check if delete checkbox is checked before validating fields (empty/invalid fields may be marked for deletion);
   *
   * If marked for deletion, handle delete logic.
   * If not marked for deletion, handle validation.
   *
   */
  public async validateDelete(): Promise<void> {
    if (this.discounts.length > 0) {
      // True === atleast one item that needs to be validated before submission
      this.validated = true;
      for (const [index, year] of this.discounts.entries()) {
        const deleteMe = this.forDeletion.some((d) => d == index);
        if (!deleteMe) {
          this.$v.discounts.$each.$iter[index].$touch();
          if (this.$v.discounts.$each.$iter[index].$invalid) {
            this.validated = false; // Form will not submit if any of the items switch boolean to false
          }
        } else {
          this.$v.discounts.$each.$iter[index].$reset();
        }
      }
      this.submitForm();
    } else {
      this.validated = true;
      this.submitForm();
    }
  }

  public validateNoDelete(): void {
    this.$v.discounts.$touch();
    if (!this.$v.$invalid) {
      this.validated = true;
      this.submitForm();
    }
  }

  get discountsSelect(): any {
    return [
      { handle: CustomerDiscounts.Standard, display_name: "Standard" },
      { handle: CustomerDiscounts.Reorder, display_name: "Reorder" },
      { handle: CustomerDiscounts.EarlyBuy, display_name: "Early Buy" },
    ];
  }

  public async submitForm(): Promise<void> {
    if (this.validated) {
      if (this.forDeletion.length > 0) {
        this.discounts = this.discounts.filter((d, i) => {
          if (!this.forDeletion.includes(i)) {
            return d;
          }
        });
      }
      this.discounts = this.discounts.map((d) => {
        d.amt = this.decimal.format(
          Number((d.amt as string).replace(/[^0-9.-]+/g, "").trim())
        );
        switch (d.handle) {
          case CustomerDiscounts.Standard:
            d.display_name = "Standard";
            break;
          case CustomerDiscounts.Reorder:
            d.display_name = "Reorder";
            break;
          case CustomerDiscounts.EarlyBuy:
            d.display_name = "Early Buy";
            break;
        }
        return d;
      });
      await this.updateCustomer();
      this.$emit("close");
      EventBus.$emit("updateCustomer");
    }
  }

  public async updateCustomer(): Promise<void> {
    const reqObj = {
      business_info: this.data.business_info ? this.data.business_info : {},
    } as CustomerSchema;
    reqObj.business_info.discounts = this
      .discounts as CustomerSchema["business_info"]["discounts"];
    try {
      await this.customerService.updateCustomer(reqObj, this.data._id);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public addItem(): void {
    const item = {
      handle: "",
      amt: 0,
    };
    this.discounts.push(item);
  }

  public oneEntryPerYear(handle: string): boolean {
    let isPresent = false;
    isPresent = this.discounts.find((d) => d.handle == handle) as any;
    if (isPresent) {
      return true;
    } else {
      return false;
    }
  }
}
